import React, { useEffect, useState, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './scss/title.scss';
import Color from '@tool/color';
import ShapeIcon from '@static/icon/shape01.png';

interface IProps {
  title: string,
  subtitle: string,
  hideDesc?: boolean,
  right?: ReactNode,
  onIndi?: () => void,
}
interface IState { }

const Title = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { title, subtitle, hideDesc, right, onIndi } = props;

  useEffect(() => {
    return () => { };
  }, []);

  return (
    <section className="wealfare-title-111">
      <p className="big-111">
        <img src={ShapeIcon} alt="" />
        <strong>{title}</strong>
      </p>
      <p className="title-113">
        <span className="span-11" />
        <b>{subtitle}</b>
        {/* {!hideDesc ? (
          <span className="indi-11" aria-hidden="true"
            onClick={onIndi}>
            指标说明</span>
        ) : null} */}
      </p>
      {right}
    </section>
  );
};

export default observer(Title);
